import React, { useMemo } from "react";
import { getAccuratePixels } from "../../utils/global";

function Rj11({ isDownloadMode, downloadAs }) {
  const totalWidth = isDownloadMode ? 283 + "px" : getAccuratePixels(283);
  const totalHeight = isDownloadMode ? 596 + "px" : getAccuratePixels(596);
  const width = isDownloadMode ? 172 + "px" : getAccuratePixels(172);
  const height = isDownloadMode ? 177 + "px" : getAccuratePixels(177);

  const marginTop = isDownloadMode ? 331 + "px" : getAccuratePixels(331);

  const border = useMemo(() => {
    if (downloadAs == "cutout-png") {
      return "1px solid black";
    }

    if (downloadAs == "icon-png") {
      return null;
    }

    return "2px solid #6495ED";
  }, [downloadAs]);

  return (
    <div
      style={{
        width: totalWidth,
        height: totalHeight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          marginBlockStart: marginTop,
          width: width,
          height: height,
          border: border,
          // marginLeft: "8px",
        }}
      ></div>
    </div>
  );
}

export default Rj11;
